import { AxiosError, AxiosResponse } from 'axios';
import { push } from 'redux-first-history';

import { OnResponseRejected } from '@libs/axios/types';

import authService from '@app/libs/auth/authService';
import embeddedService from '@app/libs/embedded/embeddedService';
import redirect from '@app/libs/embedded/redirect';
import store from '@app/store';
import { resetAuthentication } from '@app/store/account/actions';
import { initializeUser, withAnalytics } from '@app/store/analytics/actions';
import { modalOpen, modalUnauthorizedClose } from '@app/store/modal/actions';

import { isModusignAPI } from '../utils';

const isPathnameThatShouldBeBypassed = (pathname: string): boolean => {
  const pathnameDenylist: RegExp[] = [/^\/participant$/];
  return pathnameDenylist.some((expr) => expr.test(pathname));
};

const is401AxiosResponse = (response?: AxiosResponse<unknown>) => response?.status === 401;

const isResponseForModusignApi = (url?: string) => url && isModusignAPI(url);

/**
 * 모두싸인 API에서 HTTP 401 응답을 반환할 때 세션을 만료시키기 위한 interceptor
 */
export const onRejected: OnResponseRejected = (error: AxiosError) => {
  const { config, response } = error;

  if (
    (isResponseForModusignApi(config.url) || isResponseForModusignApi(config.baseURL)) &&
    is401AxiosResponse(response)
  ) {
    if (!config.bypass401 && !isPathnameThatShouldBeBypassed(window.location.pathname)) {
      if (authService.hasAccessToken()) {
        const { dispatch } = store;
        dispatch(withAnalytics(initializeUser(), resetAuthentication()));
        dispatch(modalUnauthorizedClose());
        authService.removeTokens();
        if (embeddedService.isEmbedded) {
          const { redirectUrl } = embeddedService;
          dispatch(
            modalOpen('CONFIRM', {
              title: '만료된 URL',
              content: 'URL이 만료되었습니다.\n다시 발급해 주세요.',
              onClose: () => {
                redirect(redirectUrl);
              },
            })
          );
        } else {
          dispatch(push({ pathname: '/authentication/signin', search: window.location.search }));
        }
      }
    }
  }
  return Promise.reject(error);
};
